export default __webpack_public_path__ + "static/media/rock-n-roll.de8056ea.jpg";